import { useLocation } from "react-router-dom";

const SITE_URL = `https://${import.meta.env.VITE_ROOT_DOMAIN}`;

export default function Canonical() {
  const { pathname } = useLocation();

  const canonicalPath = pathname === "/" ? "" : `${pathname}`;

  return <link rel="canonical" href={`${SITE_URL}${canonicalPath}`} />;
}
